import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./proxy"; // register Odoo db axios interceptor early
import App from "./App";
import { Provider } from "react-redux";
import { persistor, store } from "./apis/store";
import { CookiesProvider } from "react-cookie";
import { I18nextProvider } from "react-i18next";
import i18n from "./translations/i18";
import { PersistGate } from "redux-persist/integration/react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <CookiesProvider>
          <I18nextProvider i18n={i18n}>
            <App />
          </I18nextProvider>
        </CookiesProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
